export function SearchHistoryText({ text }) {
	return <span className="history__text">{text}</span>;
}
